<section class="dashboard-shell">
  @if (dashboardStatus.INADIMPLENTE) {
    <div class="banner-grid">
      <article class="status-banner status-banner-warning">
        <mat-icon>warning</mat-icon>
        <div>
          <strong>Existem mensalidades em atraso.</strong>
          <p>Regularize os pagamentos para manter a continuidade do contrato e o livre acesso ao seu box.</p>
        </div>
      </article>

      @if (gatewayStatus.gatewayActive) {
        @if (dashboardStatus.MOSTRAR_BANNER_CARTAO_CREDITO) {
          <button type="button" class="status-banner status-banner-info clickable-banner" (click)="cadastrarCartaoCredito()">
            <mat-icon>credit_card</mat-icon>
            <div>
              <strong>Cadastre um cartão para cobrança automática.</strong>
              <p>Evite esquecimentos, juros e multas por atraso.</p>
            </div>
          </button>
        } @else {
          <a class="status-banner status-banner-success clickable-banner" routerLink="/principal/cartoes-credito">
            <mat-icon>check_circle</mat-icon>
            <div>
              <strong>Você já possui um cartão cadastrado.</strong>
              <p>Seus contratos podem ser pagos automaticamente.</p>
            </div>
          </a>
        }
      }
    </div>
  }

  <mat-card class="dashboard-card" *ngIf="clientName">
    <mat-card-content>
      <header class="dashboard-header">
        <div class="hello-badge" aria-hidden="true">👋</div>
        <div>
          <h1>Olá, {{ clientName }}!</h1>
          <p>Confira suas faturas em aberto e acompanhe seus contratos.</p>
        </div>
      </header>

      <mat-tab-group class="dashboard-tabs" animationDuration="0ms">
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon>receipt_long</mat-icon>
            <span>Faturas em aberto</span>
          </ng-template>

          <section class="table-panel">
            <div class="table-scroll">
              <table mat-table [dataSource]="invoiceDataSource" class="invoice-table">
                <ng-container matColumnDef="numero">
                  <th mat-header-cell *matHeaderCellDef>Nº</th>
                  <td mat-cell *matCellDef="let row">
                    <button type="button" class="invoice-link" (click)="openMovement(row.invoiceId.toString())">{{ row.numero }}</button>
                  </td>
                </ng-container>

                <ng-container matColumnDef="descricao">
                  <th mat-header-cell *matHeaderCellDef>Descrição</th>
                  <td mat-cell *matCellDef="let row">
                    <div class="description-cell">{{ row.descricao }}</div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="vencimento">
                  <th mat-header-cell *matHeaderCellDef>Vencimento</th>
                  <td mat-cell *matCellDef="let row">
                    <div class="icon-cell">
                      <mat-icon>calendar_today</mat-icon>
                      <span>{{ row.vencimento }}</span>
                    </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="total">
                  <th mat-header-cell *matHeaderCellDef>Total</th>
                  <td mat-cell *matCellDef="let row">{{ row.total }}</td>
                </ng-container>

                <ng-container matColumnDef="situacao">
                  <th mat-header-cell *matHeaderCellDef>Situação</th>
                  <td mat-cell *matCellDef="let row">
                    <span [ngClass]="row.situacao == 'Aguardando pagamento' ? 'status-aguardando' : 'status-inadimplente'">{{ row.situacao }}</span>
                  </td>
                </ng-container>

<!--                <ng-container matColumnDef="acoes">-->
<!--                  <th mat-header-cell *matHeaderCellDef aria-label="Ações"></th>-->
<!--                  <td mat-cell *matCellDef="let row" class="actions-cell">-->
<!--                    <button-->
<!--                      mat-icon-button-->
<!--                      type="button"-->
<!--                      [matMenuTriggerFor]="invoiceMenu"-->
<!--                      [matMenuTriggerData]="{ invoice: row }"-->
<!--                      aria-label="Abrir ações da fatura"-->
<!--                    >-->
<!--                      <mat-icon>more_vert</mat-icon>-->
<!--                    </button>-->
<!--                  </td>-->
<!--                </ng-container>-->

                <tr mat-header-row *matHeaderRowDef="invoiceColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: invoiceColumns;" (click)="openMovement(row.invoiceId.toString())"></tr>
              </table>
            </div>

            @if (!invoiceDataSource.data.length) {
              <div class="empty-state">Não há nenhuma cobrança em aberto no momento.</div>
            }

            <mat-paginator
              [pageSize]="25"
              [pageSizeOptions]="[10, 25, 50]"
              showFirstLastButtons
              aria-label="Paginação de faturas"
            ></mat-paginator>
          </section>
        </mat-tab>

        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon>description</mat-icon>
            <span>Contratos</span>
          </ng-template>

          <section class="table-panel contracts-panel">
            @if (contractRows.length) {
              <div class="contracts-grid">
                @for (contract of contractRows; track contract.id) {
                  <article class="contract-card">
                    <div class="contract-meta">
                      <span class="contract-number">Contrato {{ contract.id }}</span>
                      <span class="contract-status" [class.contract-status-warning]="contract.inadimplente">
                        {{ contract.inadimplente ? 'Inadimplente' : 'Em dia' }}
                      </span>
                    </div>
                    <strong>{{ contract.unidade }}</strong>
                    <p>Locação em {{ contract.dataLocacao }}</p>
                    <div class="contract-footer">
                      <span>{{ contract.valorBase }}</span>
                      <button mat-button type="button" (click)="openContract(contract.id.toString())">Ver contrato</button>
                    </div>
                  </article>
                }
              </div>
            } @else {
              <div class="empty-state">Nenhum contrato ativo no momento.</div>
            }
          </section>
        </mat-tab>
      </mat-tab-group>
    </mat-card-content>
  </mat-card>
</section>

<mat-menu #invoiceMenu="matMenu">
  <ng-template matMenuContent let-invoice="invoice">
    <button mat-menu-item (click)="openMovement(invoice.invoiceId.toString())">
      <mat-icon>open_in_new</mat-icon>
      <span>Abrir fatura</span>
    </button>
  </ng-template>
</mat-menu>
